import { GridColumns, GridValueGetterParams } from "@mui/x-data-grid";
import React from "react";
import { useTranslation } from "react-i18next";
import QuickfiltersContainer from "../../../containers/Quickfilters/QuickfiltersContainer/QuickfiltersContainer";
import { StatusQuickfilter } from "../../../containers/Quickfilters/StatusesQuickfilter/StatusQuickfilter";
import { useStatusQuickFilter } from "../../../containers/Quickfilters/StatusesQuickfilter/useStatusQuickFilter";
import useAuthorization from "../../../custom-hooks/useAuthorization/useAuthorization";
import { PropsFilter } from "../../../models/api/props-filter/props-filter";
import { HiringClientDTO } from "../../../models/recruiting/hiring-clients/hiring-client-dto";
import { renderCellExpand } from "../../../reusable-components/RenderCellExpand/RenderCellExpand";
import { FormField } from "../../../reusable-components/Table/AddEditItem/interfaces";
import Table from "../../../reusable-components/Table/Table";
import { HiringClientsApiService } from "../../../services/recruiting/hiring-clients/hiring-clients-api.service";
import { UsersApiService } from "../../../services/users/users-api.service";
import { AUTHORIZATIONS } from "../../../utils/constants/authorization-constants";
import { FT_HRT } from "../../../utils/constants/filter-tables-constants";
import { intlFormatDateShort } from "../../../utils/time-utils";

const HiringClients = () => {
  const { t } = useTranslation();
  const tRP = "pages.system_settings.tables.hiring_clients";
  const translationFields = `${tRP}.fields`;

  const isAllowedEditAddDelete = useAuthorization([AUTHORIZATIONS.RecruitingAccess.CanAddHiringClients]);

  const { statusQuickFilter, setStatusQuickFilter } = useStatusQuickFilter(false);

  const columns: GridColumns = [
    {
      field: "name",
      valueGetter: ({ row }) => row?.name,
      headerName: t(`${translationFields}.hiring_client`),
      headerAlign: "center",
      flex: 1,
      maxWidth: 200,
    },
    {
      field: "owner",
      valueGetter: ({ row }) => row?.owner?.name,
      headerName: t(`${translationFields}.owner`),
      headerAlign: "center",
      flex: 1,
      maxWidth: 200,
    },
    {
      field: "createdOn",
      valueGetter: (params: GridValueGetterParams) => intlFormatDateShort(params?.row["createdAt"]),
      headerName: t(`${translationFields}.created_on`),
      headerAlign: "center",
      flex: 1,
      maxWidth: 110,
      align: "center",
    },
    {
      field: "status",
      valueGetter: ({ row }) => (row?.status ? "Inactive" : "Active"),
      headerName: t(`${translationFields}.status`),
      headerAlign: "center",
      flex: 1,
      maxWidth: 100,
      align: "center",
    },
    {
      field: "comment",
      valueGetter: ({ row }) => row?.comment,
      headerName: t(`${translationFields}.comment`),
      headerAlign: "center",
      flex: 1,
      renderCell: renderCellExpand,
    },
  ];

  const formFields: FormField[] = [
    {
      labelKey: t(`${translationFields}.owner`),
      field: "owner",
      fieldType: "dropdown",
      apiService: new UsersApiService(),
    },
    {
      labelKey: t("common_words.name"),
      field: "name",
      fieldType: "textfield",
    },
    {
      labelKey: t(`${translationFields}.status`),
      field: "status",
      fieldType: "checkbox",
    },
    {
      labelKey: t("common_words.comment"),
      field: "comment",
      fieldType: "textarea",
    },
  ];

  const defaultItem: Partial<HiringClientDTO> = {
    name: "",
    owner: null,
    status: false,
    comment: "",
  };

  return (
    <>
      {isAllowedEditAddDelete && (
        <Table
          translationRootPath={tRP}
          columns={columns}
          serviceApi={new HiringClientsApiService()}
          formFields={formFields}
          defaultItem={defaultItem}
          filter={FT_HRT}
          readOnly={!isAllowedEditAddDelete}
          propsFilter={
            {
              status: statusQuickFilter.statuses.isTrueOrFalse,
            } as PropsFilter
          }
          quickFilters={
            <QuickfiltersContainer>
              <StatusQuickfilter
                quickFilters={statusQuickFilter}
                handleChangeQuickFilters={setStatusQuickFilter}
                tab={"other"}
              />
            </QuickfiltersContainer>
          }
        />
      )}
    </>
  );
};

export default HiringClients;
